/**
 * p(Koenigin faellt) nach gewonnenem Raubzug: clamp(base + scale * (1 - 1/r), 0, max).
 * Klar ueberlegene Angriffe toeten fast sicher, knappe Siege selten. r <= 1 (kein Sieg) -> 0.
 */
export function queenKillChance(balance, ratio) {
    const q = balance.queen;
    if (!(ratio > 1))
        return 0;
    const inv = Number.isFinite(ratio) ? 1 / ratio : 0;
    const p = q.killBase + q.killScale * (1 - inv);
    return Math.min(q.killMax, Math.max(0, p));
}
/** Wuerfel gegen die Chance; der Wurf kommt von aussen (Tests sind deterministisch). */
export function queenDies(balance, ratio, roll) {
    return roll < queenKillChance(balance, ratio);
}
/** Reifezeit einer Weisellarve in Sekunden (Weiselzelle beschleunigt multiplikativ, Weltgeschwindigkeit teilt). */
export function queenBreedSeconds(balance, cellLevel, worldSpeed) {
    const q = balance.queen;
    const lvl = Math.max(1, cellLevel);
    const factor = Math.pow(1 - q.cellSpeedPerLevel, lvl - 1);
    return Math.max(1, Math.round((q.breedSeconds * factor) / Math.max(0.01, worldSpeed)));
}
/** Wie viele Reservekoeniginnen (fertig oder als Larve) ein Stock halten darf. */
export function maxReserveQueens(balance, cellLevel) {
    if (cellLevel <= 0)
        return 0;
    return balance.queen.reservePerCellLevel * cellLevel;
}
/** Ende der Weisellosigkeit (Notschlupf), auf ganze Millisekunden. */
export function queenlessDeadline(balance, since, worldSpeed) {
    const ms = (balance.queen.queenlessHours * 3_600_000) / Math.max(0.01, worldSpeed);
    return new Date(Math.ceil(since.getTime() + ms));
}
/** Bienen, die beim Notschlupf verloren gehen (abgerundet, mindestens 0). */
export function emergencyLoss(balance, count) {
    return Math.max(0, Math.floor(count * balance.queen.emergencyLossFraction));
}
//# sourceMappingURL=queen.js.map